import React from 'react';
import { Select } from "antd";
import { IReporteeSelectViewProps } from "./type/reportee-select.types";

const ReporteeSelectView: React.FC<IReporteeSelectViewProps>=(props)=>{

    function handleScroll(e: React.UIEvent<HTMLDivElement>) {
        const el = e.target as HTMLElement;
        if (props.paginationControls.isLoading) return;

        const isAtTop = el.scrollTop <= 5;
        const isAtBottom =
            el.scrollTop + el.clientHeight >= el.scrollHeight - 5;

        if (isAtTop && props.paginationControls.hasPrevious) {

            props.paginationControls.loadPrev();
        }

        if (isAtBottom && props.paginationControls.hasNext) {

            props.paginationControls.loadNext();
        }
    }

    return (
        <Select
            value={props.selectedId}
            className={'employee-select'}
            popupClassName="employee-select-dropdown"
            onChange={(val: string) => props.onChange(val)}
            onPopupScroll={handleScroll}
            placeholder={props.placeholder}
        >
            {props.includeAllEmployeeOption && <Select.Option key={''} value={''}>All Employee</Select.Option>}
            {props.list.map((emp) => (
                <Select.Option key={emp.id} value={emp.id}>
                    <div className="employee-option">
                        <span className="name">{emp.name}</span>
                        <span className={`designation ${emp.designation?'':'hide'}`}>{emp.designation}</span>
                    </div>
                </Select.Option>
            ))}
        </Select>
    )

}

export default ReporteeSelectView;
